function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#empty-newsfeed-pages_svg__paint0_linear_750_11023)",
  d: "M20 22h186v95H20z"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-newsfeed-pages_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-newsfeed-pages_svg__filter0_d_750_11023)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 173,
  height: 24,
  rx: 2,
  transform: "matrix(1 0 0 -1 20 60)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("rect", {
  x: 148,
  y: 41,
  width: 40,
  height: 14,
  rx: 2,
  fill: "#0085FF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 86,
  y: 41,
  width: 57,
  height: 14,
  rx: 2,
  fill: "#DBDFE5"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 88,
  y: 44,
  width: 52,
  height: 8,
  rx: 2,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M168.471 50.994a.53.53 0 101.058 0h-1.058zm1.058-5.99a.53.53 0 10-1.058 0h1.058zm2.466 3.525a.53.53 0 000-1.059v1.059zm-5.99-1.059a.53.53 0 000 1.059V47.47zm3.524 3.524v-5.99h-1.058v5.99h1.058zm2.466-3.524h-5.99v1.059h5.99V47.47z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  width: 155,
  height: 34,
  rx: 2,
  transform: "matrix(1 0 0 -1 17 104)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  x: 148.5,
  y: 94.5,
  width: 2,
  height: 4.5,
  rx: 0.5,
  fill: "#DBDFE5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.086 98.542c-.765.867-3.067.29-4.086 0V95.25c.382-.577 1.368-.924 1.75-2.223.273-.93 1.571-.527 1.571 0s-.382 1.926 0 1.927c.382 0 1.313-.245 1.529 0 .382.432 0 2.722-.764 3.588zM166.438 96l.229.1a.25.25 0 000-.2l-.229.1zm-6.876 0l-.229-.1a.25.25 0 000 .2l.229-.1zM163 98.5a4 4 0 003.667-2.4l-.458-.2A3.5 3.5 0 01163 98v.5zm-3.667-2.4A4 4 0 00163 98.5V98a3.5 3.5 0 01-3.209-2.1l-.458.2zM163 93.5a4 4 0 00-3.667 2.4l.458.2A3.5 3.5 0 01163 94v-.5zm3.667 2.4A4 4 0 00163 93.5v.5a3.5 3.5 0 013.209 2.1l.458-.2z",
  fill: "#DBDFE5"
}), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M163 97a1 1 0 100-2 1 1 0 000 2z",
  stroke: "#DBDFE5",
  strokeWidth: 0.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  fill: "#A0AFBE",
  d: "M17 75h150v6H17zM17 84h150v6H17zM17 93h76v6H17z"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "empty-newsfeed-pages_svg__paint0_linear_750_11023",
  x1: 108,
  y1: 64.123,
  x2: 13,
  y2: 64.123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "empty-newsfeed-pages_svg__filter0_d_750_11023",
  x: 12,
  y: 30,
  width: 189,
  height: 40,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_750_11023"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_750_11023",
  result: "shape"
})));
function SvgEmptyNewsfeedPages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 140,
    fill: "none"
  }, props), _ref, /*#__PURE__*/React.createElement("mask", {
    id: "empty-newsfeed-pages_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 22,
    width: 186,
    height: 95
  }, _ref2), _ref3, _ref4);
}
export default SvgEmptyNewsfeedPages;